/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EquipmentScheduleCalendarStates } from './equipment-schedule-calendar-states';
import { EquipmentScheduleTypes } from './equipment-schedule-types';


export interface EquipmentScheduleAssignmentItemResponseDto { 
    assignmentId?: string;
    scheduleId?: string;
    scheduleName?: string | null;
    scheduleType?: EquipmentScheduleTypes;
    isEnabled?: boolean;
    triggerSummary?: string | null;
    windowStart?: string | null;
    windowEnd?: string | null;
    state?: EquipmentScheduleCalendarStates;
}



